import { render, staticRenderFns } from "./CollegeListTiqian.vue?vue&type=template&id=6dda2057&scoped=true&"
import script from "./CollegeListTiqian.vue?vue&type=script&lang=js&"
export * from "./CollegeListTiqian.vue?vue&type=script&lang=js&"
import style0 from "./CollegeListTiqian.vue?vue&type=style&index=0&id=6dda2057&scoped=true&lang=less&"
import style1 from "./CollegeListTiqian.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda2057",
  null
  
)

export default component.exports